/* @ngInject */
export default function ($rootScope, SEVENGcmSocketSvc) {
  $rootScope.$on('SevenClientCore:ready', function () {
    SEVENGcmSocketSvc.startConnection();
  });
}
